import { useCallback, useState } from 'react'
import { loadService } from '../services/loadService'
import type { LoadResponse } from '../services/loadService'

interface UseLoadsReturn {
  loads: LoadResponse[]
  isLoading: boolean
  error: Error | null
  getLoadsByTag: (tagId: string) => Promise<void>
}

export const useLoads = (): UseLoadsReturn => {
  const [loads, setLoads] = useState<LoadResponse[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const getLoadsByTag = useCallback(async (tagId: string) => {
    setIsLoading(true)
    try {
      const loadData = await loadService.getLoadsByTag(tagId)
      setLoads(loadData)
      setError(null)
    } catch (err) {
      console.error('Failed to load data:', err)
      setError(err instanceof Error ? err : new Error('Failed to load data'))
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    loads,
    isLoading,
    error,
    getLoadsByTag,
  }
}
